/**
 * Created by miguel on 23/2/17.
 */

class EventDetailCell extends UITableViewCell
{
    delegate = null;

    private conceptLabel:MUILabel = null;
    private quantityTextField:MUITextField = null;
    private priceTextField:MUITextField = null;
    private discountTextField:MUITextField = null;
    private totalLabel:MUILabel = null;
    private typeIcon:MUIView = null;
    private disclosureIcon:MUIView = null;

    private _item:EventItem = null;

    private cf:MIONumberFormatter = MUIWebApplication.sharedInstance().delegate.currencyFormatter;
    private nf:MIONumberFormatter = MUIWebApplication.sharedInstance().delegate.numberFormatter;

    awakeFromHTML()
    {
        this.conceptLabel = MUIOutlet(this, 'concept-lbl', 'MUILabel');

        this.quantityTextField = MUIOutlet(this, 'quantity-tf', 'MUITextField');
        if (this.quantityTextField != null) {
            this.quantityTextField.formatter = this.nf;
            this.quantityTextField.setOnChangeText(this, function(this:EventDetailCell, control:MUITextField, value:string){
                if (!(this._item instanceof EventItemLine)) return;
                let line = this._item as EventItemLine;
                line.quantity = value.length > 0 ? this.nf.numberFromString(value) : 0;
                this.recalculate(line);
            });
        }

        this.priceTextField = MUIOutlet(this, 'price-tf', 'MUITextField');
        if (this.priceTextField != null) {
            this.priceTextField.formatter = this.cf;
            this.priceTextField.setOnChangeText(this, function(this:EventDetailCell, control:MUITextField, value:string){
                if (!(this._item instanceof EventItemLine)) return;
                let line = this._item as EventItemLine;
                line.unitPrice = value.length > 0 ? this.cf.numberFromString(value) : 0;
                this.recalculate(line);
            });
        }

        this.discountTextField = MUIOutlet(this, 'discount-tf', 'MUITextField');
        if (this.discountTextField != null) {
            this.discountTextField.formatter = this.cf;
            this.discountTextField.setOnChangeText(this, function(this:EventDetailCell, control:MUITextField, value:string){
                if (!(this._item instanceof EventItemLine)) return;
                let line = this._item as EventItemLine;
                this._discountAmount = value.length > 0 ? this.cf.numberFromString(value) : 0;
                this.recalculate(line);
            });
        }

        this.totalLabel = MUIOutlet(this, 'total-lbl', 'MUILabel');
        this.typeIcon = MUIOutlet(this, 'type-icon', 'MUIView');
        this.disclosureIcon = MUIOutlet(this, 'disclosure-icon', 'MUIView');

        // this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _discountAmount:number = 0;

    private recalculate(line:EventItemLine){
        let qty = line.quantity || 0;
        let price = line.unitPrice || 0;
        let discount = this._discountAmount || 0;
        line.totalAmount = (qty * price) - discount;
        if (this.totalLabel != null) this.totalLabel.text = this.cf.stringFromNumber(line.totalAmount);
        if (this.delegate != null && typeof this.delegate.lineCellDidUpdateTotal === 'function') {
            this.delegate.lineCellDidUpdateTotal(this);
        }
    }

    set item(i:EventItem)
    {
        this._item = i;

        if (this.conceptLabel != null) this.conceptLabel.text = i.concept;

        if (i instanceof EventItemLine) {
            let line = i as EventItemLine;
            if (this.quantityTextField != null) this.quantityTextField.text = line.quantity != null ? this.nf.stringFromNumber(line.quantity) : '';
            if (this.priceTextField != null) this.priceTextField.text = line.unitPrice != null ? this.cf.stringFromNumber(line.unitPrice) : '';
            if (this.discountTextField != null) this.discountTextField.text = '';
            this._discountAmount = 0;
            if (this.totalLabel != null) this.totalLabel.text = line.totalAmount != null ? this.cf.stringFromNumber(line.totalAmount) : '';

            // Type icon
            if (this.typeIcon != null) {
                MUICoreLayerRemoveStyle(this.typeIcon.layer, 'product');
                MUICoreLayerRemoveStyle(this.typeIcon.layer, 'menu');
                if (line.product != null) MUICoreLayerAddStyle(this.typeIcon.layer, 'product');
                else if (line.menu != null) MUICoreLayerAddStyle(this.typeIcon.layer, 'menu');
            }

            // Disclosure icon (only for menu lines)
            if (this.disclosureIcon != null) {
                this.disclosureIcon.hidden = (line.menu == null);
            }
        }
    }
}

class EventDetailAddCell extends UITableViewCell
{
    delegate = null;
    private addButton:MUIButton = null;
    private typeSegmented:MUISegmentedControl = null;
    private conceptTextField:MUITextField = null;
    private _phase:EventItemPhase = null;
    private _selectedType:number = 0; // 0 = product, 1 = menu

    private searchTimer:MIOTimer = null;
    private searchString:string = null;

    awakeFromHTML()
    {
        this.addButton = MUIOutlet(this, 'add-line-btn', 'MUIButton');
        if (this.addButton) this.addButton.setAction(this, this.addButtonDidPress);

        this.typeSegmented = MUIOutlet(this, 'type-segmented', 'MUISegmentedControl');
        if (this.typeSegmented) this.typeSegmented.setAction(this, function(control, index){
            this._selectedType = index;
        });

        this.conceptTextField = MUIOutlet(this, 'concept-tf', 'MUITextField');
        this.conceptTextField.setOnEnterPress(this, function(textField, value){
            this.commitValue(value);
        });
        this.conceptTextField.setOnChangeText(this, function(control:MUITextField, value:string){
            this.searchString = value;
            if (this.searchTimer != null) this.searchTimer.invalidate();
            this.searchTimer = MIOTimer.scheduledTimerWithTimeInterval(500, false, this, function(timer:MIOTimer){
                this.searchTimerFired();
                this.searchTimer = null;
            });
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private searchTimerFired(){
        let value = this.searchString;
        if (value == null || value.trim().length == 0) return;

        if (this._selectedType == 0){
            // Product search
            AppHelper.sharedInstance().showSelectProductViewControllerFromView(this.conceptTextField, value, null, this, this.productDidSelect, null, null);
        } else {
            // Menu search
            AppHelper.sharedInstance().showCustomSelectViewControllerFromView(this.conceptTextField, "Menu", "name", "name CONTAINS '" + value + "'", this, this.menuDidSelect);
        }
    }

    private productDidSelect(controller:SelectEntityViewController, product:Product){
        this.conceptTextField.text = product.name;
        if (this.delegate != null && typeof this.delegate.addCellDidSelectProduct === 'function'){
            this.delegate.addCellDidSelectProduct(this, this._phase, product);
        }
        this.conceptTextField.text = null;
    }

    private menuDidSelect(controller:SelectEntityViewController, menu:Menu){
        this.conceptTextField.text = menu.name;
        if (this.delegate != null && typeof this.delegate.addCellDidSelectMenu === 'function'){
            this.delegate.addCellDidSelectMenu(this, this._phase, menu);
        }
        this.conceptTextField.text = null;
    }

    private addButtonDidPress(){
        this.commitValue(this.conceptTextField.text);
    }

    private commitValue(value:string){
        let name = value?.trim();
        if (name == null || name.length == 0) return;

        if (this.delegate != null && typeof this.delegate.addCellDidEnter === 'function'){
            this.delegate.addCellDidEnter(this, this._phase, name, this._selectedType);
        }
        this.conceptTextField.text = null;
    }

    set phase(value:EventItemPhase){
        this._phase = value;
    }
}